<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left">
				<el-form-item label="头像" prop="username" style="width: 450px;">
				   <el-upload
				     class="upload-border"
				     action="/manage/images/upload"
				     :show-file-list="false"
				     :on-success="uploadSuccess">
				     <img v-if="form.avatar" :src="form.avatar" class="w-100 h-100">
				     <i v-else class="el-icon-plus uploader-icon"></i>
				   </el-upload>
				</el-form-item>
				<el-form-item label="账号名称" prop="username" style="width: 450px;">
				   <el-input v-model="form.username" placeholder="请输入账号名称" size="small" clearable></el-input>
				</el-form-item>
				<el-form-item label="账号密码" prop="password" style="width: 450px;">
				   <el-input v-model="form.password" placeholder="请输入账号密码" size="small" clearable></el-input>
				   <small class="text-danger font-s">为空表示不修改密码</small>
				</el-form-item>
				<el-form-item label="手机号码" prop="mobile" style="width: 450px;">
				   <el-input v-model="form.mobile" placeholder="请输入手机号码" type="number" size="small" clearable></el-input>
				</el-form-item>
				<el-form-item>
				   <el-button type="primary" size="small" @click="submit" style="width: 250px;">确定</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: '',
				autoRequest: false,
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				form:{
					username:'',
					password:'',
					mobile:'',
					avatar:'',
				},
				rules:{
					username: [
					  { required: true, message: '请输入名称', trigger: 'blur' }
					],
					mobile: [
					  { required: true, message: '请输入手机号码', trigger: 'blur' }
					],
				},
				info:{},
			}
		},
		mounted() {
			this.getAdminInfo()
		},
		methods:{
			getAdminInfo(){
				this.axios.get('/manage/admin/info').then(res=>{
					if(res.status){
						this.info = res.data
						this.form.id = res.data.id
						this.form.username = res.data.username
						this.form.mobile = res.data.mobile
						this.form.avatar = res.data.avatar
					}
				})
			},
			uploadSuccess(e){
			   if(e.status){
				 this.form.avatar = e.data.url
			   }
			},
			reset() {
			  this.form = {
				  username:'',
				  password:'',
				  mobile:'',
				  avatar:'',
			  }
			  this.resetForm('form')
			},
			submit(){
				this.$refs.form.validate(valid => {
				  if (valid) {
					  this.axios.post('/manage/admin/toEdit', this.form).then(res => {
					    if (res.status) {
					      this.$message.success('修改成功')
					    } else {
					      this.$message.error(res.msg)
					    }
					  })
				  }
				})
			},
		}
	}
</script>
<style>
</style>